import { useMeasures } from '../../../../../hooks/state/useMeasures'
import {
  borderWidth,
  cellSpacinH,
  cellSpacinV,
  panelDimensions,
} from '../../model/helper/verandaDimensions'

const calcOffsetAndCount = (
  length: number,
  borderWidth: number,
  spaceBetween2Cells: number
) => {
  const cellLength = panelDimensions + spaceBetween2Cells
  const counts = Math.max(Math.floor(length / cellLength), 1)
  const spaceCount = Math.max(counts - 1, 1)
  const cellCompletLength =
    panelDimensions * counts + spaceBetween2Cells * spaceCount
  const borderMin =
    Math.round(((length - cellCompletLength) / 2) * 10000) / 10000

  const count = borderMin < borderWidth ? counts - 1 : counts

  const startOffset =
    (length - panelDimensions * count - spaceBetween2Cells * (count - 1)) / 2

  const offset = spaceBetween2Cells + panelDimensions
  const dynamicBorder = borderWidth
  return { startOffset, offset, count, dynamicBorder }
}

export const useCellCountAndOffset = () => {
  const { userWidth, roofLogWidth, polesTopNumber } = useMeasures()

  const width = userWidth / (polesTopNumber - 1)

  const {
    startOffset: startOffsetWidth,
    offset: offsetWidth,
    count: countWidth,
  } = calcOffsetAndCount(
    width,
    borderWidth,
    roofLogWidth < width ? cellSpacinV : cellSpacinH
  )

  const {
    startOffset: startOffsetLength,
    offset: offsetLength,
    count: countLength,
  } = calcOffsetAndCount(
    roofLogWidth,
    borderWidth,
    roofLogWidth >= width ? cellSpacinV : cellSpacinH
  )

  return {
    countLength,
    countWidth,
    offsetLength,
    offsetWidth,
    startOffsetLength,
    startOffsetWidth,
  }
}
